import { Routes} from '@angular/router';
import { HomeFarmsComponent } from './content/farm/home-farms/home-farms.component';
import { LoginComponent } from './auth/login/login.component';
import { RegisterComponent } from './auth/register/register.component';
import { AccountComponent } from './auth/account/account.component';
import { ProfileComponent } from './auth/profile/profile.component';
import { MyFarmsComponent } from './auth/my-farms/my-farms.component';
import { CreateFarmComponent } from './content/farm/create-farm-stepper/create-farm/create-farm.component';
import { ParticularFarmComponent } from './content/farm/particular-farm/particular-farm.component';
import { AdminGuard } from './auth/admin.guard';
import { MapPruebaComponent } from './content/farm/map-prueba/map-prueba.component';
import { EditProfileComponent } from './auth/edit-profile/edit-profile.component';
import { EditFarmComponent } from './auth/edit-farm/edit-farm.component';
import { ConditionsComponent } from './shared/conditions/conditions.component';

export const AppRoutes: Routes = [
   { path : '', pathMatch: 'full', component: HomeFarmsComponent },
   { path : 'home', component: HomeFarmsComponent },
   { path : 'auth/signin', component: LoginComponent },
   { path : 'auth/register', component: RegisterComponent },
   { path : 'farm', component: CreateFarmComponent, canActivate: [AdminGuard] },
   { path : 'edit-farm/:id', component: CreateFarmComponent, canActivate: [AdminGuard] },
   { path : 'farmprueba', component: MapPruebaComponent },
   { path : 'particular-farm/:id', component: ParticularFarmComponent },
   { path : 'politica-privacidad', component: ConditionsComponent },
   { path : 'auth/account',
      component: AccountComponent,
      canActivate: [AdminGuard],
      children: [
         {
            path: 'profile',
            component: ProfileComponent,
            canActivate: [AdminGuard]
         },
         {
            path: 'myfarms',
            component: MyFarmsComponent,
            canActivate: [AdminGuard]
         },
         {
            path: 'edit-profile',
            component: EditProfileComponent,
            canActivate: [AdminGuard]
         },

      ]
   },
   {
      path: 'edit-farm/:id',
      component: EditFarmComponent,
      canActivate: [AdminGuard]
   },
   { path : 'auth/account/profile', component: ProfileComponent, canActivate: [AdminGuard]  },
   { path: '**', redirectTo: ''}
];

